import { StyleSheet } from 'aphrodite';
import { SPACE, THEME } from '../../../components-v2/Theme/theme';

export const styleSheet = StyleSheet.create({
	root: {
		display: 'flex',
		flexDirection: 'column',
		gap: SPACE[8],
		width: '100%',
	},
	askIcon: {
		color: THEME.colors.primary.main,
	},
	textarea: {
		fieldSizing: 'content',
		maxHeight: 120,
		minHeight: 0,
		paddingBottom: SPACE[8],
		paddingTop: SPACE[8],
	},
	starters: {
		display: 'flex',
		flexWrap: 'wrap',
		gap: SPACE[8],
	},
});
